import React from 'react';
import PropTypes from 'prop-types';
import styles from '../../styles/citation-request/CitationTile.module.scss';
import { rolesUnderCouncilMembers } from '../../services/constants';
import { connect } from 'react-redux';

const CitationRequestTile = props => {
  const { citationRequest, onTileClick } = props;
  let tileClass;
  if (citationRequest.status) {
    const status = citationRequest.status.toLowerCase();
    switch (status) {
      case 'approved':
        tileClass = styles['approved'];
        break;
      case 'delivered':
        tileClass = styles['delivered'];
        break;
      case 'pending':
        tileClass = styles['pending'];
        break;
      case 'in-progress':
        tileClass = styles['progress'];
        break;
      case 'completed':
        tileClass = styles['completed'];
        break;
      case 'withdrawn':
        tileClass = styles['withdrawn'];
        break;
      default:
        tileClass = '';
        break;
    }
  }

  return (
    <div
      onClick={() => {
        onTileClick(citationRequest);
      }}
      className={styles['citation-requests-list-box']}>
      <div className={styles['citation-requests-list-idx']}>
        <div className={`${styles['report-sidelabel-container']} ${tileClass}`}>
          <p className={`${styles['report-sidelabel-text']}`}>
            {citationRequest.status}
          </p>
        </div>
      </div>
      <div className={styles['citation-requests-list-content']}>
        <p className={styles['citation-requests-list-title']}>
          {citationRequest.honoree}
        </p>
        {rolesUnderCouncilMembers.includes(props.userProfile.role) ? (
          <p className={styles['citation-requests-list-subtitle']}>
            Council Member: {citationRequest.council_member.full_name}
          </p>
        ) : (
          <p className={styles['citation-requests-list-subtitle']}>
            Requested by: {citationRequest.requested_by.full_name}
          </p>
        )}
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    userProfile: state.userReducer.userProfile,
    userList: state.userReducer.userList,
  };
};

CitationRequestTile.propTypes = {
  citationRequest: PropTypes.shape({
    honoree: PropTypes.string.isRequired,
  }).isRequired,
  id: PropTypes.number,
  onTileClick: PropTypes.func.isRequired,
};

export default connect(mapStateToProps)(CitationRequestTile);
